import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { TextHighlightEl } from "common/components/text-highlight";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { hasSlot } from "common/util/dom";
import { Visibility, VisibilityEvents } from "../base/stackable";
import { SvgIconEl } from "../svg-icon";
import { Direction } from "./types";
import { OtherTogglePanelSource } from "./constants";
export function template() {
  let collapseTooltipText = `${this.state.isCollapsed ? `Show` : `Collapse`} ${this.attr(`panel-name`)}`;
  const collapseShortcutLabel = this.collapseShortcutLabel;
  if (collapseShortcutLabel) {
    collapseTooltipText += ` ${collapseShortcutLabel}`;
  }
  const showContentFooter = hasSlot(this, `footer`) || this.attr(`show-collapse-button`) || this.showAlignmentToggle();
  return /* @__PURE__ */ jsx("div", {
    sel: ".wrapper",
    class: {
      "align-bottom": this.helpers.getAlignment() === Direction.Bottom,
      "align-right": this.helpers.getAlignment() === Direction.Right,
      "align-left": this.helpers.getAlignment() === Direction.Left,
      "has-open-dropdown": this.state.hasOpenDropdown,
      "is-collapsed": this.state.isCollapsed,
      "is-resizing": this.state.isResizing
    },
    attrs: { elref: `wrapper` },
    on: {
      [VisibilityEvents[Visibility.Open]]: () => this.update({ hasOpenDropdown: true }),
      [VisibilityEvents[Visibility.Closed]]: (ev) => this.update({ hasOpenDropdown: ev.detail.stackSize !== 1 })
    }
  }, this._headerContent && /* @__PURE__ */ jsx("div", {
    sel: ".content-header",
    attrs: { elref: `contentHeader` }
  }, this._headerContent), /* @__PURE__ */ jsx("div", {
    sel: ".content-wrapper",
    attrs: { elref: `contentWrapper` }
  }, /* @__PURE__ */ jsx("slot", null), !this.state.isCollapsed && this.attr(`is-trial-org`) && this.helpers.getTrialDaysLeft() > 0 ? /* @__PURE__ */ jsx("div", {
    sel: ".trial-info"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".trial-details"
  }, "Growth Plan Trial", ` `, /* @__PURE__ */ jsx(TextHighlightEl, {
    sel: ".days-left",
    attrs: { theme: this.helpers.getDaysLeftTheme(), text: this.helpers.getDaysLeftText() }
  }, /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      text: `Your Growth Plan free trial ends ${this.helpers.getTrialEndDateString()}.
[Learn more \u2192](https://docs.mixpanel.com/docs/pricing/billing#reverse-trial-beta)`,
      placement: Placement.Right
    }
  }))), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".billing-btn",
    attrs: {
      elref: `billingBtn`,
      theme: ButtonTheme.Secondary,
      "not-focusable": true,
      "style-override": `a.mp-button-container.mp-button-secondary { background-color: transparent; }`
    },
    on: { click: () => this.helpers.clickedAddBillingInfo() }
  }, "Add Billing Info")) : null), showContentFooter && /* @__PURE__ */ jsx("div", {
    sel: ".content-footer",
    class: {
      "show-alignment-toggle": this.showAlignmentToggle()
    }
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `footer` }
  }), this.showAlignmentToggle() && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".alignment-toggle",
    attrs: {
      elref: `alignmentToggle`,
      theme: ButtonTheme.Tertiary,
      "not-focusable": true,
      tooltip: {
        text: this.helpers.getAlignmentToggleTooltipText(),
        placement: this.helpers.getSideButtonTooltipDirection()
      }
    },
    on: {
      click: () => {
        this.update({ isHoveringAlignmentToggle: false });
        this.toggleAlignment();
      },
      mouseover: () => this.update({ isHoveringAlignmentToggle: true }),
      mouseleave: () => this.update({ isHoveringAlignmentToggle: false })
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: this.helpers.getAlignmentToggleIcon() }
  })), this.attr(`show-collapse-button`) && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".collapse-button",
    attrs: {
      elref: `collapseButton`,
      theme: ButtonTheme.Tertiary,
      "not-focusable": true,
      tooltip: {
        text: collapseTooltipText,
        placement: this.helpers.getSideButtonTooltipDirection()
      }
    },
    on: { click: () => this.toggleCollapsed({ source: OtherTogglePanelSource.Button }) }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: this.helpers.getCollapseButtonIconDirection() }
  }))), !this.state.isCollapsed && !this.attr(`fixed-size`) && /* @__PURE__ */ jsx("div", {
    sel: ".resize-handle",
    on: {
      mousedown: (ev) => this.startResizing(ev)
    },
    class: {
      "resize-right": this.helpers.getResizeDirection() === Direction.Right,
      "resize-left": this.helpers.getResizeDirection() === Direction.Left,
      "resize-top": this.helpers.getResizeDirection() === Direction.Top
    },
    attrs: { elref: `resizeHandle` }
  }));
}
